<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('headcounts')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("add") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <company-headcount-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :companyId="company_id"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";

export default {
  extends: CoreLibrary,
  name: "HeadcountDatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      company_id: this.$attrs['props'].company_id,
      id:'',
      isViewModalActive: false,
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "demo-crud-table",
      rowData: {},
      options: {
        url: actions.COMPANY_HEADCOUNT_LIST+'?company_id='+this.$attrs['props'].company_id,
        name: this.$t("demo_crud"),
        datatableWrapper: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("staff_role"),
            type: "custom-html",
            key: "role",
            modifier: (value) => {
              return `<span>${this.$t(value.name)}</span>`;
            },
          },
          {
            title: this.$t("staff_count"),
            type: "custom-html",
            key: "staff_count",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("office_branch"),
            type: "custom-html",
            key: "branch",
            modifier: (value) => {
              return `<span>${this.$t(value.office_name)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    openViewModal() {
      this.isViewModalActive = true;
    },
    closeViewModal() {
      $("#demo-view-Modal").modal("hide");
      this.isViewModalActive = false;
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.COMPANY_HEADCOUNT_EDIT}/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.CERTIFICATE_CATEGORY_DELETE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },
};
</script>
